import React from 'react';

function CheckboxGroup({ options, selectedValues, onChange }) {
  const handleChange = (value) => {
    const newSelection = selectedValues.includes(value)
      ? selectedValues.filter((item) => item !== value)
      : [...selectedValues, value];
    onChange(newSelection);
  };

  return (
    <div className="space-y-3">
      {options.map((option) => (
        <label key={option.value} className="flex items-center group cursor-pointer">
          <input
            type="checkbox"
            className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 transition-colors"
            value={option.value}
            checked={selectedValues.includes(option.value)}
            onChange={() => handleChange(option.value)}
          />
          <span className="ml-3 text-sm text-gray-700 group-hover:text-gray-900 transition-colors">
            {option.label}
          </span>
        </label>
      ))}
    </div>
  );
}

export default CheckboxGroup;